export default "/assets/mm_en-blue.png";